import { render, staticRenderFns } from "./katseluoikeudet.vue?vue&type=template&id=5e45f51a&scoped=true&"
import script from "./katseluoikeudet.vue?vue&type=script&lang=ts&"
export * from "./katseluoikeudet.vue?vue&type=script&lang=ts&"
import style0 from "./katseluoikeudet.vue?vue&type=style&index=0&id=5e45f51a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e45f51a",
  null
  
)

export default component.exports